// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { RootState } from "../store"
import { getBackendUrl } from "../utils/backendUrl"
import type { DeleteUserRequest } from "./elmApiTypes"

// Types
import type { StoresResponse } from "./api/types/Store"
// Default values
import { DefaultPaginatedResponse } from "./api/defaults/Common"

const backend_url_env = import.meta.env.VITE_BACKEND_URL
const baseUrl = getBackendUrl(backend_url_env)

// Define a service using a base URL and expected endpoints
export const elmApi = createApi({
  reducerPath: "elmApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    // Inject headers with JWT token from state (does not apply to OPTIONS requests)
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.idToken
      if (token) {
        headers.set("authorization", token)
      }
      return headers
    },
  }),
  tagTypes: ["Stores"],
  endpoints: (builder) => ({
    deleteSelf: builder.mutation<any, DeleteUserRequest>({
      query: (body) => ({
        url: `/public/elm_user`,
        method: "DELETE",
        body,
      }),
    }),
    // Stores
    getStores: builder.query<StoresResponse, void>({
      query: () => `/stores`,
      providesTags: (result = DefaultPaginatedResponse) => [
        ...result.records.map(({ uid }) => ({ type: "Stores", uid } as const)),
        { type: "Stores" as const, id: "LIST" },
      ],
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useDeleteSelfMutation, useGetStoresQuery } = elmApi
